<template>
  <div>
    <v-btn icon small @click="onClick">
      <v-icon :size="size === 'large' ? '20' : '16'" color="#828282"
        >fal fa-share</v-icon
      >
    </v-btn>
    <span
      :class="[size === 'large' ? 'text-md-subtitle-2 body-2' : 'caption']"
      class="grey--text"
    >
      {{ count }} <translate>Shares</translate> </span
    >
  </div>
</template>
<script>
export default {
  name: "ButtonShare",
  props: ["size", "count"],
  data: () => ({}),
  computed: {
    token() {
      return this.$store.state.auth.token;
    },
  },
  methods: {
    onClick() {
      if (!this.token) {
        this.$router.push({ name: "login" });
        return;
      }
      this.$emit("click");
    },
  },
};
</script>